export default [
  {
    path: "/health",
    component: () => import("$views/Health"),
    meta: {
      permissionInfo: {
        key: "health100",
      },
    },
  },
];
